import { ClinicConfig } from "fe-common/graphql/clinic/clinicTypes";
import { ClinicConfigKeys } from "fe-common/graphql/clinic/clinicConfigKeys";
import { migrateClinicSettingsToV2 } from "./migrateClinicSettingsToV2";
import { JsonObject } from "fe-common/graphql";
const EMPTY = {};
export const getV2ClinicSettings = (clinicSettings: ClinicConfig) => {
  // TODO: translate older structured configs to new ones
  return !clinicSettings
    ? EMPTY
    : clinicSettings[ClinicConfigKeys.UnifiedConfigString] ||
        migrateClinicSettingsToV2(clinicSettings) ||
        EMPTY;
};

// In older versions there was a bug when migrating old settings and the migrated
// object was stringified twice, which leave us ith { '0': 'a", '1': 'b' ....}
// kind of values - discard of them using this helper function
export const clearErrorlyStringifiedValues = (settings: object) => {
  return Object.entries(settings || {}).reduce(
    (acc, [currentKey, currentValue]) => {
      if (
        typeof currentValue === "string" &&
        parseInt(currentKey).toString() === currentKey
      ) {
        return acc;
      }
      return { ...acc, [currentKey]: currentValue } as object;
    },
    {} as object,
  );
};
